<ui-toolbar-top [title]="msg.nav.user_account" [state]="scrollState()" [backVisible]="true"></ui-toolbar-top>

<ui-user-account #content cdkScrollable></ui-user-account>